module.exports = __webpack_public_path__ + "img/Work.1197c600.webp";